export default __webpack_public_path__ + "d3d148b31b3d54d757184d4e00520e1f.png";